import "./HeroSection.css";
import { Link } from "react-router-dom";
import heartbackground from "../images/heartbackground.avif";

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="section-shell hero-shell">
        <div className="hero-copy">
          <span className="eyebrow">Medical Device Commercialization</span>
          <h1 className="hero-title">
            Bring medtech strategy, sales operations, and analytics into one sharp operating system.
          </h1>
          <p className="hero-description hero-description--lead">
            Ammen Consulting helps medical device teams move from launch planning
            to commercial execution with disciplined sales operations,
            performance visibility, and market-ready strategy.
          </p>
          <p className="hero-description">
            We support founders, operators, and leadership teams that need more
            than advice. The work spans practical commercialization planning,
            CRM and reporting infrastructure, and the analytics required to make
            faster decisions with confidence.
          </p>

          <div className="hero-actions">
            <Link to="/contact" className="button button--primary">
              Start a Conversation
            </Link>
            <a href="#past-clients" className="button button--secondary">
              View Client History
            </a>
            <a href="#testimonials" className="button button--secondary">
              View Client Experience
            </a>
          </div>

          <div className="hero-highlights">
            <div className="hero-stat surface-card">
              <span className="hero-statValue">Since 2010</span>
              <span className="hero-statLabel">Commercialization support across launches and scale-ups</span>
            </div>
            <div className="hero-stat surface-card">
              <span className="hero-statValue">Revenue Clarity</span>
              <span className="hero-statLabel">Sales reporting, territory performance, and operating insight</span>
            </div>
            <div className="hero-stat surface-card">
              <span className="hero-statValue">Execution</span>
              <span className="hero-statLabel">Strategy translated into systems, process, and decision support</span>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-media surface-card">
            <img
              alt="Anatomical heart model"
              src={heartbackground}
              className="hero-image"
            />
          </div>

          <div className="hero-note surface-card">
            <span className="hero-noteLabel">What clients need most</span>
            <p>
              Go-to-market discipline, sales enablement, and reporting that leadership can actually use.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
